import IconName from "types/IconName";
import {DateTime} from "luxon";
import {SiteDescriptor} from "./Site";

export type Link = {
    id: number
    uuid: string
    text: string
    url: string
    offline_url: string
    icon: IconName
    sites: Array<SiteDescriptor>
    order: number
    is_featured: boolean
    featured_at: DateTime | null
    is_published: boolean
    published_at: DateTime | null
    is_attached: boolean
    linkable_type?: string
    linkable_id?: number
    category: string
    options: LinkOptions[]
    created_at: DateTime
    updated_at: DateTime
}

export type AttachedLink = {
    id: number
    uuid: string
    text: string
    url: string
    offline_url: string
    icon: IconName
    order: number
    category: string
    options: LinkOptions[]
    created_at: DateTime
    updated_at: DateTime
}

export type LinkAPIData = {
    id?: number | string
    category?: string
    text?: string
    url?: string
    options?: LinkOptions[]
    offline_url?: string
    icon?: IconName
    order?: number
    featured_at?: string | null
    published_at?: string | null
    site_ids?: number[]
}

export enum LinkOptions {
    AUTO_LOGIN = "auto-login",
    MEMBERS_ONLY = "members-only",
}